import "core-js/modules/es.promise.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import fileDownload from 'js-file-download';
export const isFileSystemApiSupported = window.showSaveFilePicker !== undefined;
export const fileSystemApiSaveFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (file, name) {
    // create a new handle
    const newHandle = yield window.showSaveFilePicker({
      suggestedName: name
    });

    // create a FileSystemWritableFileStream to write to
    const writableStream = yield newHandle.createWritable();

    // write our file
    yield writableStream.write(file);

    // close the file and write the contents to disk.
    yield writableStream.close();
  });
  return function fileSystemApiSaveFile(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export const baseDownload = (file, name, mime) => fileDownload(file, name, mime);
export const download = (file, name, mime) => baseDownload(file, name, mime);